import StatusChip, { ChipType } from 'components/@extended/StatusChip';
import { useCallback } from 'react';
import { PricelistLabelType, PricingKind } from 'types/pricelists';
import { getClassifierText, t } from 'utils/getTranslations';
import { useClassifiers } from 'utils/useClassifiers';

export interface LabelButtonsProps {
    labels: string[];
    pricingKind?: PricingKind;
}

export const LabelButtons = ({ labels, pricingKind }: LabelButtonsProps): JSX.Element => {
    const { classifiers } = useClassifiers({
        codes: ['PRICELIST_LABEL_TYPE'],
    });

    const getLabel = useCallback(
        (labelTypeCode: string) => getClassifierText(classifiers['PRICELIST_LABEL_TYPE'], labelTypeCode),
        [classifiers]
    );
    const getStatusChipType = useCallback((labelTypeCode: string): ChipType => {
        switch (labelTypeCode) {
            case PricelistLabelType.MATCHES_MODEL:
            case PricelistLabelType.MODEL:
            case PricelistLabelType.CASE_BASED:
            case PricelistLabelType.CONTRACT_BASED:
                return 'neutral';
            case PricelistLabelType.EXPIRED:
                return 'inactive';
            case PricelistLabelType.SCHEDULED:
                return 'info';
            case PricelistLabelType.VALID:
                return 'success';
        }
    }, []);

    const caseValidity = [] as React.ReactNode[];
    const caseSource = [] as React.ReactNode[];

    labels.forEach((labelTypeCode) => {
        const chip = (
            <StatusChip type={getStatusChipType(labelTypeCode)} label={getLabel(labelTypeCode)} key={labelTypeCode} />
        );
        if (
            labelTypeCode === PricelistLabelType.EXPIRED ||
            labelTypeCode === PricelistLabelType.VALID ||
            labelTypeCode === PricelistLabelType.SCHEDULED
        )
            caseValidity.push(chip);
        else caseSource.push(chip);
    });

    // In a price list card the new design puts the labels on its bottom line, under the name and the rates.
    return (
        <div className="new:order-last flex flex-wrap items-center justify-start gap-1">
            {caseValidity}
            {caseSource}
            {pricingKind === PricingKind.EMPLOYEE ? (
                <StatusChip type="neutral" label={t('pricelists.employee.per-employee')} />
            ) : null}
        </div>
    );
};
